import { FaHome, FaUserCog, FaUserPlus, FaTrash } from "react-icons/fa";
import { AiFillWarning } from "react-icons/ai";
import { MdEmail, MdNotifications } from "react-icons/md";
import { RiFolderWarningFill, RiUserSearchFill } from "react-icons/ri";
import ManagementPortal from "../pages/Management/Portal";
import ManagementUsers from "../pages/Management/Users";
import CreateUser from "../pages/Management/CreateUser";
import ExceptionManagement from "../pages/Internal/ExceptionManagement";
import ExportErrors from "../pages/Internal/ExportErrors";
import TempDisconnectedEntities from "../pages/Internal/TempDisconnectedEntities";
import EmailInbox from "../pages/Internal/EmailInbox";
import UploadErrors from "../pages/Internal/UploadErrors";
import UserRoles from "../pages/Internal/UserRoles";
import NotificationSettings from "../pages/Internal/NotificationSettings";
import UserActivity from "../pages/Internal/UserActivity";
import DeletedDocuments from "../pages/Internal/DeletedDocuments";
import { InternalSidebarItemType, applyComingSoon } from "./InternalLinks";

const ManagementLinksRaw: InternalSidebarItemType[] = [
    { id: 1, tooltipText: 'Portal', Icon: FaHome, link: '/management/portal', element: ManagementPortal },
    { id: 2, tooltipText: 'Users', Icon: FaUserCog, link: '/management/users', element: ManagementUsers },
    { id: 3, tooltipText: 'Create User', Icon: FaUserPlus, link: '/management/users/create', element: CreateUser },
    { id: 4, tooltipText: 'User Activity', Icon: RiUserSearchFill, link: '/internal/users-activity', element: UserActivity },
    { id: 5, tooltipText: 'Deleted Documents', Icon: FaTrash, link: '/internal/deleted-documents', element: DeletedDocuments },
    { id: 6, tooltipText: 'Exception Management', Icon: AiFillWarning, link: '/internal/exception-management', element: ExceptionManagement },
    { id: 7, tooltipText: 'Export Errors', Icon: RiFolderWarningFill, link: '/internal/export-errors', element: ExportErrors, comingSoon: true },
    { id: 8, tooltipText: 'Temp Disconnected', Icon: AiFillWarning, link: '/internal/temp-disconnected-entities', element: TempDisconnectedEntities },
    { id: 9, tooltipText: 'Email Inbox', Icon: MdEmail, link: '/internal/email-inbox', element: EmailInbox },
    { id: 10, tooltipText: 'Upload Errors', Icon: AiFillWarning, link: '/internal/upload-errors', element: UploadErrors },
    { id: 11, tooltipText: 'User Roles', Icon: FaUserCog, link: '/internal/user-roles', element: UserRoles },
    { id: 12, tooltipText: 'Notification Settings', Icon: MdNotifications, link: '/internal/notification-settings', element: NotificationSettings },
];

export const ManagementLinks: InternalSidebarItemType[] = applyComingSoon(ManagementLinksRaw);
